import React,{useState, useEffect} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,Row,Col,Label,Input } from 'reactstrap';
import { checkOut, roomCurrent } from 'network/ApiAccomodation';

function CheckOutModal(props) {
  const [about, setAbout] = useState('-');
  const [deduction, setDeduction] = useState(0);

  const [pillow, setPillow] = useState(false);
  const [duvet, setDuvet] = useState(false);

  const prices = {
    pillow : 30,
    duvet : 50
  }
  const managerId = JSON.parse(localStorage.getItem('user'))._id

  console.log(props.roomInfo.userId)

  const handleCheckOut = async()=>{
    const resp = await checkOut(props.room,deduction,about,managerId,props.roomInfo.userId)
    if(resp.data.success){
      props.mapReload(props.room)
      props.outToggle(props)
    }else{
      alert('Something went wrong')
    }
  }

  const handleCheckBoxClick = (e,item,itemBox,itemFunc)=>{
    itemBox ? setDeduction(deduction - prices[item]) : setDeduction(deduction + prices[item])
    itemFunc(!itemBox)
  }
  
  return (
    <Modal isOpen={props.outModal} toggle={props.outToggle}>
        <ModalHeader>Check Out</ModalHeader>
        <ModalBody>
          <Label>Check List:</Label>
          <Row>
            <Col>
              <label>Text<input checked={pillow} onChange={(e)=>handleCheckBoxClick(e,'pillow',pillow,setPillow)} type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
              <br/>
              <label>Text<input checked={duvet} onChange={(e)=>handleCheckBoxClick(e,'duvet',duvet,setDuvet)} type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
              <br/>
              <label>Text<input type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
            </Col>
            <Col>
              <label>Text<input type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
              <br/>
              <label>Text<input type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
              <br/>
              <label>Text<input type="checkbox" name="checkbox" value="value" className='ml-2'/></label>
            </Col>
          </Row>
          <p>
            - Check this <br/>
            - Check that <br/>
            Write in the about what was deducted and how much
          </p>
          <Label>Deposit Deductions:</Label>
          <Input type='number' onChange={(e)=>setDeduction(e.target.value)} value={deduction}/>
          <Label>About:</Label>
          <Input type='text' onChange={(e)=>setAbout(e.target.value)} />
            {props.room}
        </ModalBody>
        <ModalFooter>
          <Button className='btn-danger' onClick={handleCheckOut} >Check Out</Button>
        </ModalFooter>
    </Modal>
  )
}

export default CheckOutModal